import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import {
  alpha,
  Box,
  styled,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export const CustomTableHead = styled(TableHead)(
  ({ theme }) => `
          th {
            border-bottom: 2px solid ${theme.palette.brand.black};
            font-weight : 700;
            font-size: 1rem;
          }
        `,
);

export const CustomTableCell = styled(TableCell)(
  ({ theme, active, width }) => `
  width: ${`${width}px`};
font-size: 16px;
border-left: ${
    active ? `5px solid ${theme.palette.primary.main}` : '4px solid transparent'
  };

& a {
  color: inherit;
}
`,
);

export const TableHeadCell = styled(Box)`
  display: flex;
  border: none;
  justify-content: start;
  align-items: center;
  gap: 20px;
`;

export const SortIcons = styled(Box)`
  width: 14px;
  height: 31px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 0px;
`;

export const ArrowIcon = styled(Box)`
  height: 20px;
  cursor: pointer;
`;

export const KeyboardArrowUpIconStyled = styled(KeyboardArrowUpIcon, {
  shouldForwardProp: (prop: any) => {
    return prop !== 'active';
  },
})<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>(({ active, theme }) => ({
  color: active ? theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const KeyboardArrowDownIconStyled = styled(KeyboardArrowDownIcon, {
  shouldForwardProp: (prop: any) => {
    return prop !== 'active';
  },
})<{
  active: boolean;
  theme: { palette: { primary: { main: string } } };
}>(({ active, theme }) => ({
  color: active ? theme.palette.primary.main : 'inherit',
  fontSize: '20px',
}));

export const CustomTableRow = styled(TableRow)(
  ({ theme, active }) => `
       cursor: pointer;
       background: ${active ? theme.palette.brand.lightBlue : ''};

       &:hover {
        background: ${alpha(theme.palette.primary.main, 0.04)};
      }
      `,
);

export const TableBodyContainer = styled(TableContainer)`
  height: ${({ height }: { height: string }) => height};
  overflow: auto;
`;

export const InViewBoxContainer = styled(Box)`
  height: 50px;
`;

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ContentContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 40px;
`;
